import * as React from 'react';
import { observer } from 'mobx-react';
import { createGlobalStyle } from 'styled-components';
import { computed } from 'mobx';
interface GlobalStylesProps {
    children?: any;
}

@observer
class GlobalStyles extends React.Component<GlobalStylesProps> {
    @computed
    get StyledGlobalStyles() {
        return createGlobalStyle`
        * {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
        }
    `;
    }

    render() {
        const StyledGlobalStyles = this.StyledGlobalStyles;
        return <StyledGlobalStyles />;
    }
}

export default GlobalStyles;



// WEBPACK FOOTER //
// ./src/GlobalStyles.tsx